import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { NotificationsPage } from '@/notifications/pages';

export const Route = createFileRoute('/notifications')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: NotificationsRoute
});

function NotificationsRoute() {
  return <NotificationsPage/>;
}
